"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("card/reward/base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var RewardCertificateCard =
/*#__PURE__*/
function (_RewardCard) {
  babelHelpers.inherits(RewardCertificateCard, _RewardCard);

  function RewardCertificateCard() {
    babelHelpers.classCallCheck(this, RewardCertificateCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(RewardCertificateCard).apply(this, arguments));
  }

  babelHelpers.createClass(RewardCertificateCard, [{
    key: "renderAdditionalTopItems",
    value: function renderAdditionalTopItems() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("span", {
        className: "material-icons print-icon",
        "data-icon": "print"
      }));
    }
  }]);
  return RewardCertificateCard;
}(_base.default);

exports.default = RewardCertificateCard;